module.exports = function () {
	Innophos.Pages.SearchPage.PaginationEvents();
};
